import { render, staticRenderFns } from "./CustomerDialog.vue?vue&type=template&id=45acd8a8"
import script from "./CustomerDialog.vue?vue&type=script&lang=ts"
export * from "./CustomerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45acd8a8')) {
      api.createRecord('45acd8a8', component.options)
    } else {
      api.reload('45acd8a8', component.options)
    }
    module.hot.accept("./CustomerDialog.vue?vue&type=template&id=45acd8a8", function () {
      api.rerender('45acd8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/CustomerDialog.vue"
export default component.exports